<ng-template #modalRef>
  <div class="pl-modal--{{size}} child-sale-modal-shell">
    <div class="header-close-icon">
      <header class="pl-modal__header se-modal__header">
        <h1 pl-grid="1/1@phone" pl-grid-el class="pl-heading--large se-modal__header--text">{{ 'CHILD_SALE.MODAL.header' | translate }}
          <se-fe-icon (click)="closeForm()" seFeDataName="remove" seFeDataEmphasis="low"
            class="close-button" data-testid="close-button"></se-fe-icon>
        </h1>
      </header>
      <div class="progress-bar-div">
        <se-fe-progress-bar aria-labelledby="progress-bar" [seFeDataSegmented]="true" [seFeDataCompleted]="completed"
          [seFeDataTotal]="total" style="height: 4px;">
        </se-fe-progress-bar>
        <div id="progress-bar">
          <span class="progress-bar">{{ completed }} of {{ total }} completed</span>
        </div>
      </div>
      <div class="sale-info">
        @if (step === 1) {
<h3 data-testid="sale-number-step1">{{ 'CHILD_SALE.MODAL.sale_info_1' | translate }} {{ sales_number }}</h3>
}
        @if (step === 2) {
<h3 data-testid="sale-number-step2">{{ 'CHILD_SALE.MODAL.sale_info_2' | translate }} {{ sales_number }}</h3>
}
        <p style="margin-bottom: 1rem;" data-testid="customer-name">{{ salesperson_full_name }} {{ 'CHILD_SALE.MODAL.notifying_customer_message' | translate }}</p>
      </div>
    </div>
    @if (step === 1) {
<section #scrollRef class="pl-modal__content">
      <form [formGroup]="multiselectForm">
        <label class="pl-field__label">{{ 'CHILD_SALE.MODAL.form_message' | translate }}</label>
        <div pl-grid="1/1@phone" pl-grid-el class="flex">
          <div pl-grid="5/6@phone" pl-grid-el>
            <se-fe-form-field-multiselect class="multiselect" #itemSelector id="childSale" data-item-search
              [attr.aria-busy]="itemSearchStatus === 'loading' ? 'true' : null"
              formControlName="multiselect"
              seFeDataMaxInput="1"
              [seFeDataHideSearchIcon]="true"
              [seFeDataOptions]="options"
              [seFeDataSearchMinLength]="itemSearchMinLength"
              [seFeDataQueryValidators]="queryValidators"
              [seFeDataComfy]="false"
              [seFeDataNotFoundMessage]="itemSearchNotFoundMessageKey | translate"
              seFeDataPlaceholder="Select"
              [seFeDataQueryConfig]="queryConfig"
              (seFeQueryChange)="searchInput($event, true, itemSelector)" data-testid="item-selector">
            </se-fe-form-field-multiselect>
            @if (itemSearchStatusMessageKey; as messageKey) {
<div
              class="pl-help-text--below item-search-status"
              data-testid="item-search-status" aria-live="polite">
              {{ messageKey | translate }}
              @if (itemSearchStatus === 'error') {
<se-fe-button seFeDataEmphasis="low" [seFeDataSmall]="true"
                (click)="retryItemSearch()" data-testid="item-search-retry">
                {{ 'CHILD_SALE.MODAL.item_search_retry' | translate }}
              </se-fe-button>
}
            </div>
}
            @if (itemSearchStatus === 'empty') {
<se-fe-button seFeDataEmphasis="low" [seFeDataSmall]="true"
              (click)="clearItemSearch()" data-testid="item-search-clear">
              {{ 'CHILD_SALE.MODAL.item_search_clear' | translate }}
            </se-fe-button>
}
            @if (!itemError) {
<span class="error-item">{{ 'CHILD_SALE.MODAL.item_error' | translate }}.</span>
}
          </div>
          <div pl-grid="1/6@phone" pl-grid-el>
            <se-fe-button (click)="apply()" class="apply-button" seFeDataEmphasis="medium"
              [seFeDataIsDisabled]="!multiselectForm.controls['multiselect'].value">
              {{ 'CHILD_SALE.MODAL.apply_button' | translate }}
            </se-fe-button>
          </div>
        </div>
      </form>
      <form [formGroup]="form">
        @if (getItems().length > 0) {
<se-fe-block seFeDataType="outline" class="selected-items-container">
          <div pl-grid="1/1@phone" pl-grid-el>
            <div pl-grid="tight" class="tight-container">
              <h3>{{ 'CHILD_SALE.MODAL.item_selector' | translate }}</h3>
              <div pl-grid="1/2@phone" pl-grid-el class="pl-help-text--below">
                {{ 'CHILD_SALE.MODAL.item_selector_subtitle' | translate }}
              </div>
              <div pl-grid="1/2@phone" pl-grid-el class="flex">
                <h5 pl-grid="1/18@phone" pl-grid-el>
                  {{ 'CHILD_SALE.MODAL.item_selector_items' | translate }}
                </h5>
                <h5 pl-grid="1/3@phone" class="pl-text--right quantity">
                  {{ 'CHILD_SALE.MODAL.item_selector_quantity' | translate }}
                </h5>
              </div>
              <hr class="pl-divider modal-divider">
              @for (itemGroup of getItems().controls; track itemGroup; let i = $index) {
<div>
                <div [formGroup]="itemGroup" pl-grid="1/1@phone" pl-grid-el class="flex">
                  <label class="pl-field__label" pl-grid="1/6@phone" [seFeTooltipTrigger]="tooltipRef" [attr.data-testid]="'item-name-' + i">
                    {{ $safeNavigationMigration(itemGroup.get('item')?.value?.text) | trim }}
                  </label>
                  <se-fe-tooltip #tooltipRef class="tooltip">
                    {{ itemGroup.get('item')?.value?.text }}
                  </se-fe-tooltip>
                  <div pl-grid="2/6@phone" style="margin-right: 2rem; margin-top: 1rem; ">
                    <se-fe-form-field-quantity seFeDataMin="1" seFeDataMax="999" formControlName="quantity" aria-label="Quantity" [seFeEnableManualInput]="true"
                      style="margin-top: -0.5rem;">
                    </se-fe-form-field-quantity>
                    <span class="remove-button" (click)="removeItem(i)" [attr.data-testid]="'remove-item-' + i">
                      {{ 'CHILD_SALE.MODAL.remove_button' | translate }}
                    </span>
                  </div>
                </div>
              </div>
}
              <hr class="pl-divider modal-divider">
              <div pl-grid="1/1@phone" pl-grid-el class="total-items">
                <h5 data-testid="total-items">
                  {{ getTotalItems() }} {{ 'CHILD_SALE.MODAL.item_selector_total_items' | translate }}
                </h5>
              </div>
            </div>
            @if (itemsAreInvalid()) {
<span class="error-item">Please enter an integer quantity between 1 and 999 for each item.</span>
}
          </div>
        </se-fe-block>
}
        <div class="textarea">
          <se-fe-form-field [seFeDataConfig]="textareaConfig">
            <se-fe-form-field-text formControlName="textarea" [seFeDataRows]="6" data-testid="exchange-message">
            </se-fe-form-field-text>
          </se-fe-form-field>
          <label class="pl-field__label">
            {{ 'CHILD_SALE.MODAL.text_area' | translate }}
          </label>
        </div>
      </form>
    </section>
}
    @if (step === 2) {
<section class="pl-modal__content">
      @if (!error) {
<se-fe-alert style="margin: 1rem" data-testid="info-alert">
        {{ 'CHILD_SALE.MODAL.info_alert' | translate }}
        <se-fe-alert-subheader>
          {{ 'CHILD_SALE.MODAL.info_alert_subtitle' | translate }} {{ salesperson_full_name }}
        </se-fe-alert-subheader>
      </se-fe-alert>
}
      @if (error) {
<se-fe-alert style="margin: 1rem">
        {{ 'CHILD_SALE.MODAL.info_error' | translate }}
        <se-fe-alert-subheader>
          {{ 'CHILD_SALE.MODAL.info_error_subtitle' | translate }}
        </se-fe-alert-subheader>
      </se-fe-alert>
}
      <div pl-grid="1/1@phone" pl-grid-el style="display: block; margin: 1rem">
        @if (form.controls['textarea'].value) {
<div pl-grid="1/1@phone" class="block">
          <label class="pl-field__label label-medium">{{ 'CHILD_SALE.MODAL.message' | translate }}</label>
          <label class="pl-field__label">{{ form.controls['textarea'].value }}</label>
        </div>
}
        <hr class="pl-divider">
        @for (itemGroup of getItems().controls; track itemGroup; let i = $index) {
<div pl-grid="1/1@phone" class="block">
          <div [formGroup]="itemGroup" pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label class="pl-field__label" [attr.data-testid]="'item-name-' + i">
                {{ itemGroup.get('item')?.value?.text }}
              </label>
            </div>
            <div>
              <label class="pl-field__label" [attr.data-testid]="'item-quantity-' + i">
                <span>{{ items[i].price | currency }}</span>
                <span style="margin-left: 1rem;">x{{ itemGroup.get('quantity')?.value }}</span>
                <span style="margin-left: 1rem;">{{ getSum(items[i].price_cents/100, $safeNavigationMigration(itemGroup.get('quantity')?.value)) | currency }}</span>
              </label>
            </div>
          </div>
        </div>
}
        <hr class="pl-divider">
        <div pl-grid="1/1@phone" class="block">
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              @if (getItems().length === 1) {
<label class="pl-field__label">
                Subtotal ({{ getItems().length }} item)
              </label>
}
              @if (getItems().length > 1) {
<label class="pl-field__label">
                Subtotal ({{ getItems().length }} items)
              </label>
}
            </div>
            <div>
              <label class="pl-field__label" data-testid="subtotal-amount">
                {{ itemsSum() | currency }}
              </label>
            </div>
          </div>
        </div>
        <div pl-grid="1/1@phone" class="block">
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label class="pl-field__label">
                Credit
              </label>
            </div>
            <div>
              <label class="pl-field__label" data-testid="credit-amount">
                ({{ itemsSum() | currency }})
              </label>
            </div>
          </div>
        </div>
        <hr class="pl-divider">
        <div pl-grid="1/1@phone" style="display: block; margin-top: -1rem;">
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <h4 data-testid="total-items-exchanged">{{ getTotalItems() }} {{ 'CHILD_SALE.MODAL.item_selector_total_items' | translate }}</h4>
            </div>
            <div style="margin-right: 1.5rem;">
              <h4 data-testid="total-exchange-amount">
                ({{ 0 | currency }})
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
}
    <footer class="pl-modal__footer">
      <div class="pl-form-actions__button-container modal-footer-container">
        @if (step === 2) {
<div pl-grid="1/2@phone">
          <se-fe-back-button (click)="back()">
            {{ 'CHILD_SALE.MODAL.back_button' | translate }}
          </se-fe-back-button>
        </div>
}
        <div class="cancel-button">
          <se-fe-button [seFeDataEmphasis]="'low'" (click)="closeForm()" style="height: 36px !important;">
            {{ 'CHILD_SALE.MODAL.cancel_button' | translate }}
          </se-fe-button>
        </div>
        @if (step === 1) {
<se-fe-button [seFeDataEmphasis]="'high'" (click)="nextStep()"
          [seFeDataIsDisabled]="disabled" style="height: 36px !important;">
          {{ 'CHILD_SALE.MODAL.next_button' | translate }}
        </se-fe-button>
}
        @if (step === 2) {
<se-fe-button [seFeDataEmphasis]="'high'" (click)="submitForm()"
          [seFeDataIsDisabled]="submitIsInProgress">
          {{ 'CHILD_SALE.MODAL.create_exchange_button' | translate }}
        </se-fe-button>
}
      </div>
    </footer>
  </div>
</ng-template>
